import { isAfter, isValid, parseISO } from 'date-fns';

import { TWO_FA_OTP_TYPE } from 'features/preIdentity/helper';

export const checkIfUpdatingContactAllowed = (workflow) => {
    return workflow?.pre_identity_checks?.['2fa']?.metadata?.allowed_user_update ?? true;
};

export const checkIf2FAAttemptsAreLeft = (twoFaSession, type, attemptsType, userDetails = {}) => {
    const emailAttempts = twoFaSession?.[attemptsType]?.email;
    const phoneAttempts = twoFaSession?.[attemptsType]?.phone;

    if (type === TWO_FA_OTP_TYPE.EITHER) {
        const emailVerified = userDetails?.email_verified;

        const emailExhausted = !emailVerified && emailAttempts === 0;

        return emailExhausted || phoneAttempts === 0;
    }

    if (type === TWO_FA_OTP_TYPE.EMAIL) return emailAttempts === 0;

    if (type === TWO_FA_OTP_TYPE.PHONE) return phoneAttempts === 0;
};

export const checkIf2FaSessionExpired = (twoFaSession) => {
    if (!twoFaSession) return false;

    const deadline = parseISO(twoFaSession?.expireBy);

    return isValid(deadline) && isAfter(new Date(), deadline);
};

export const canRequest2faOtp = (session, otpType) => {
    const { EMAIL, PHONE } = TWO_FA_OTP_TYPE;

    const { email, phone } = session?.leftOtpAttempts ?? {};

    const isEmailEligible = otpType === EMAIL && email > 0;
    const isPhoneEligible = otpType === PHONE && phone > 0;

    return isEmailEligible || isPhoneEligible;
};
